<template>
  <ion-menu content-id="main-content" side="end" :swipe-gesture="false">
    <ion-header>
      <ion-toolbar color="white">
        <ion-title color="primary">
          {{ $t('base.menu') }}
        </ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <div>
        <ion-menu-toggle>
          <ion-button router-link="/selectProfile" expand="block" fill="clear">
            <ion-icon :icon="peopleOutline" slot="start" class="icon-med" />
            {{ $t('auth.switchProfile') }}
          </ion-button>

          <ion-button router-link="/settings" expand="block" fill="clear">
            <ion-icon :icon="cogOutline" slot="start" class="icon-med" />
            {{ $t('base.settings') }}
          </ion-button>

          <ion-button router-link="/about" expand="block" fill="clear">
            <ion-icon :icon="help" slot="start" class="icon-med" />
            {{ $t('base.about') }}
          </ion-button>

          <hr style="background-color: var(--ion-color-primary)" />

          <ion-button
            expand="block"
            fill="clear"
            color="danger"
            @click="signOut"
          >
            <ion-icon :icon="exitOutline" slot="start" class="icon-med" />
            {{ $t('auth.signOut') }}
          </ion-button>
        </ion-menu-toggle>
      </div>
    </ion-content>
  </ion-menu>
</template>

<script setup lang="ts">
import { signOut } from '@/services/auth';
import {
  IonMenu,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButton,
  IonMenuToggle,
  IonIcon,
} from '@ionic/vue';
import { peopleOutline, cogOutline, exitOutline, help } from 'ionicons/icons';
</script>
